import React from "react";
import { render } from "react-dom";
import logger from "../lib/logger";
import { BugFormWithTranslations } from "./bug-form";
var mount = function (workspaceSettings) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    logger.debug("Creating root and mounting widget in shadow...");
    var domRoot = document.createElement("div");
    domRoot.id = "bugpilot-root";
    document.body.appendChild(domRoot);
    var shadowRoot = domRoot.attachShadow({ mode: "open" });
    var reactRoot = document.createElement("div");
    reactRoot.style.position = "absolute";
    reactRoot.style.inset = "0";
    reactRoot.style.width = "0";
    reactRoot.style.height = "0";
    reactRoot.style.pointerEvents = "none";
    reactRoot.style.overflow = "hidden";
    reactRoot.style.zIndex = Number.MAX_SAFE_INTEGER.toString();
    reactRoot.id = "bugpilot-ui-root";
    shadowRoot.appendChild(reactRoot);
    render(React.createElement(BugFormWithTranslations, { key: "bugpilot-widget-".concat(workspaceSettings.id), anchorSelector: (_a = workspaceSettings.widgetSettings) === null || _a === void 0 ? void 0 : _a.elementSelector, anchorPosition: workspaceSettings.userWidgetPosition, emailRequired: true, descriptionRequired: (_b = workspaceSettings.widgetSettings) === null || _b === void 0 ? void 0 : _b.requireDescription, recordingRequired: (_c = workspaceSettings.widgetSettings) === null || _c === void 0 ? void 0 : _c.requireRecording, ribbonLabel: (_d = workspaceSettings.widgetSettings) === null || _d === void 0 ? void 0 : _d.idleText, primaryColor: (_f = (_e = workspaceSettings.widgetSettings) === null || _e === void 0 ? void 0 : _e.colors) === null || _f === void 0 ? void 0 : _f.primary, secondaryColor: (_h = (_g = workspaceSettings.widgetSettings) === null || _g === void 0 ? void 0 : _g.colors) === null || _h === void 0 ? void 0 : _h.secondary, preferredLocale: undefined }), reactRoot);
    logger.info("Widget mounted into", reactRoot);
};
var main = function () {
    var _a;
    var win = window;
    var settings = (_a = win.Bugpilot) === null || _a === void 0 ? void 0 : _a.config.workspaceSettings;
    if (!(settings === null || settings === void 0 ? void 0 : settings.enableUserWidgetV2)) {
        logger.info("Widget is disabled from workspace settings. Will check again on next page load.");
        return;
    }
    document.addEventListener("DOMContentLoaded", function () { return mount(settings); });
    if (document.readyState === "complete") {
        mount(settings);
    }
};
main();
